import services from '@/services/ConfiguracaoRastreabilidadeService';

export function cadastrarParametros(configuracao) {
    const percentualCapacidadeProdutiva =
        configuracao.percentualCapacidadeProdutiva
            ? configuracao.percentualCapacidadeProdutiva
            : 15;
    const params = {
        id: null,
        aplicarEstado: false,
        aplicarTodoEstado: true,
        excecoes: [],
        idFornecedor: null,
        idEstado: configuracao.idEstado,
        idMunicipio: null,
        distanciaRaioKm: configuracao.distanciaRaioKm,
        percentualCapacidadeProdutiva,
        tipoCadastro: 'ESTADO'
    };

    return services.cadastrarConfiguracaoRastreabilidade(params);
}

export function editarParametros(configuracao) {
    const percentualCapacidadeProdutiva =
        configuracao.percentualCapacidadeProdutiva
            ? configuracao.percentualCapacidadeProdutiva
            : 15;
    const params = {
        id: configuracao.id,
        aplicarEstado: false,
        aplicarTodoEstado: true,
        idFornecedor: null,
        excecoes: [],
        idEstado: configuracao.idEstado,
        idMunicipio: null,
        distanciaRaioKm: configuracao.distanciaRaioKm,
        percentualCapacidadeProdutiva,
        tipoCadastro: 'ESTADO'
    };

    return services.editarConfiguracaoRastreabilidade(params);
}
